import {
    AppointmentInfoPageActionCreators,
    clearTimeslotConstraint,
    setTimeslotConstraint,
    showInsurancePickerError,
} from './AppointmentInfoPageActions';
import { enterInsuranceId } from '../AppointmentDetails/AppointmentDetailsActions';
import {
    getBookingState,
    updateBookingState,
    updateExistingPatientState,
} from '../../actions/SchedulingActions';

import { paths } from '../../paths';
import {
    setPlanState,
    handleShareInsuranceCheckboxChange,
    setCarrierState,
    trackClickCarrierDropdown,
    trackClickPlanDropdown,
    trackPreloadInsuranceCarrier,
    trackPreloadInsurancePlan,
} from '../../actions/InsuranceCardActions';

import { wrapWithDispatch, pushWithQuery } from '../../utils';

export const mapDispatchToProps = (dispatch, ownProps) => ({
    clearTimeslotConstraint: () => {
        dispatch(clearTimeslotConstraint());
    },
    getBookingState: bookingId => {
        dispatch(getBookingState(bookingId));
    },
    updateBookingState: bookingState => {
        dispatch(updateBookingState(bookingState));
    },
    updateExistingPatientState: isExistingPatient => {
        dispatch(updateExistingPatientState(isExistingPatient));
    },
    onShareInsuranceCheckboxChange: checked =>
        dispatch(handleShareInsuranceCheckboxChange(checked)),
    onValidContinue: () => {
        dispatch(
            pushWithQuery(
                `${paths.selectPatientPath}/${ownProps.params.bookingId}`
            )
        );
    },
    setTimeslotConstraint: () => {
        dispatch(setTimeslotConstraint());
    },
    showInsurancePickerError: () => {
        dispatch(showInsurancePickerError());
    },
    setCarrierState: carrierId => dispatch(setCarrierState(carrierId)),
    setPlanState: planId => dispatch(setPlanState(planId)),
    trackClickCarrierDropdown: () => dispatch(trackClickCarrierDropdown()),
    trackClickPlanDropdown: () => dispatch(trackClickPlanDropdown()),
    trackPreloadInsuranceCarrier: insuranceCarrierId => {
        dispatch(trackPreloadInsuranceCarrier(insuranceCarrierId));
    },
    trackPreloadInsurancePlan: insurancePlanId => {
        dispatch(trackPreloadInsurancePlan(insurancePlanId));
    },
    ...wrapWithDispatch(AppointmentInfoPageActionCreators, dispatch),
    enterMemberId: (memberId, fromInsuranceApi) =>
        dispatch(enterInsuranceId(memberId, fromInsuranceApi)),
});

export default mapDispatchToProps;
